import api from '../../api/evaluate'

const state = {
  person: {personality: {}, needs: {}, values: {}},
  industry: {personality: {}, needs: {}, values: {}}
}

// getters
const getters = {
  person: state => state.person,
  industry: state => state.industry
}

// 業界値
const rawData = [
  [],
  [0.9791, 0.8669, 0.8904, 0.5829, 0.6958, 0.3464, 0.3226, 0.7838, 0.5172, 0.1150, 0.7140, 0.7602, 0.2608, 0.3197, 0.1966, 0.5987, 0.5872, 0.0604, 0.6306, 0.0293, 0.4199, 0.6998],
  [0.9862, 0.9305, 0.9298, 0.6770, 0.6935, 0.4284, 0.4424, 0.8252, 0.7053, 0.1551, 0.8036, 0.8897, 0.3203, 0.2637, 0.2534, 0.6756, 0.5995, 0.0610, 0.7699, 0.0109, 0.4843, 0.8429],
  [0.9889, 0.8938, 0.9008, 0.6243, 0.7099, 0.4916, 0.4482, 0.8147, 0.6799, 0.1369, 0.7374, 0.8601, 0.3317, 0.3708, 0.2887, 0.6029, 0.6104, 0.0438, 0.7332, 0.0316, 0.4119, 0.7737],
  [0.9697, 0.9021, 0.8983, 0.6238, 0.6760, 0.3952, 0.3855, 0.7760, 0.5835, 0.1101, 0.7531, 0.8043, 0.2977, 0.3078, 0.2273, 0.6509, 0.5942, 0.0501, 0.6809, 0.0160, 0.4186, 0.7606],
  [0.9886, 0.8923, 0.9198, 0.6642, 0.7521, 0.4256, 0.4085, 0.7836, 0.6761, 0.0894, 0.7084, 0.8581, 0.3423, 0.2834, 0.2572, 0.5503, 0.5864, 0.0327, 0.7713, 0.0583, 0.3787, 0.6761],
  [0.9909, 0.8735, 0.9230, 0.6404, 0.7195, 0.4663, 0.3529, 0.8213, 0.6375, 0.1185, 0.7428, 0.8282, 0.3044, 0.3712, 0.2605, 0.5474, 0.5662, 0.0443, 0.7015, 0.0421, 0.4346, 0.7208],
  [0.9749, 0.8815, 0.8843, 0.6285, 0.7121, 0.3879, 0.3708, 0.7909, 0.5749, 0.1113, 0.7147, 0.7943, 0.3065, 0.2907, 0.2162, 0.5587, 0.5799, 0.0427, 0.6932, 0.0185, 0.3736, 0.7191]
]

// mutations
const mutations = {
  setPerson (state, dataset) {
    state.person = dataset
  },
  setIndustry (state, industryIndex) {
    const v2o = function (value) {
      return {
        name: '',
        percentile: value
      }
    }

    state.industry = {
      personality: rawData[industryIndex].slice(0, 5).map(v2o),
      needs: rawData[industryIndex].slice(5, 17).map(v2o),
      values: rawData[industryIndex].slice(17).map(v2o)
    }
  }
}

// actions
const actions = {
  evaluate ({commit}, query) {
    return api.evaluate(query).then((dataset) => {
      commit('setPerson', dataset)
    })
  },
  setIndustry ({commit}, industryIndex) {
    commit('setIndustry', industryIndex)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/graphDatasets.js